import { inject, Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Content } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  adobeClickEventAnalyticsMocks,
  AnalyticsService,
  AuxiliaryNavigationAemItem,
  HeaderFooterMachCoreContentService,
  SearchFeedAem,
  UserDataService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FlyoutSearchSuperWrapperComponent {
  headerFooter = inject(HeaderFooterMachCoreContentService);
  analytics = inject(AnalyticsService);
  userDataService = inject(UserDataService);
  terms$ = new BehaviorSubject<string>('');
  flyoutContent$ = new BehaviorSubject<Content>({} as Content);
  unsubscribe$: Subject<void> = new Subject();
  emptyFlyoutContent = {} as Content;
  contentHeaderFooterSearch = {} as AuxiliaryNavigationAemItem;
  siteSearchUrl!: string;
  isReady = false;

  createFlyoutSearchContent(search: AuxiliaryNavigationAemItem): Content {
    const searchFeed = search as SearchFeedAem;
    return {
      popularSearchTitle: this.nullCheck(searchFeed?.popularLabel, ''),
      contentPopularSearch: this.nullCheck(searchFeed?.popularTopics, []),
      submitSearch: this.getSubmitSearch(searchFeed),
      searchResult: [],
      emptySearch: {
        displayText: this.nullCheck(searchFeed.noResultText, '')
      },
      formGroup: new UntypedFormGroup({
        searchInput: new UntypedFormControl('')
      }),
      suggestionsLabel: this.nullCheck(searchFeed?.suggestionsLabel, ''),
      suggestionsFilteredLabel: this.nullCheck(
        searchFeed?.suggestionsFilteredLabel,
        ''
      )
    };
  }

  nullCheck<T>(value: T | null | undefined, defaultValue: T): T {
    if (value) return value;
    return defaultValue;
  }

  getSubmitSearch(search: SearchFeedAem): {
    label: string;
    placeHolderText: string;
  } {
    return {
      label: search?.searchLabel ? search?.searchLabel : '',
      placeHolderText: search?.searchLabel ? search?.searchLabel : ''
    };
  }

  updateAnalytics(url: string): void {
    let data = adobeClickEventAnalyticsMocks;
    data = {
      ...data,
      event: 'click',
      event_detail: 'click',
      click: {
        name: 'search icon click',
        type: 'button',
        page_section: 'header:global nav',
        action: url
      }
    };
    this.analytics.setAnalytics(data);
  }
}
